import { render } from "./ReturnListe.vue?vue&type=template&id=56b624cd&ts=true"
import script from "./ReturnListe.vue?vue&type=script&lang=ts"
export * from "./ReturnListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__